import { Directive, Input, OnInit, ElementRef, HostBinding } from '@angular/core';
import * as $ from 'jquery';

export enum ScreenSize {
  xs = 1,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200
}

@Directive({
  selector: '[appFluidContainer]'
})
export class FluidContainerDirective implements OnInit {
  /* fluidUntil excludes the value that it contains,
  which means if fluidUntil==='lg' then the host element will be
  fluid for XS, SM and MD. */
  @Input() public fluidUntil: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  @HostBinding('class.container-fluid') private fluidActive: boolean;
  @HostBinding('class.container') private breakingActive: boolean;

  constructor(private _element: ElementRef) {
    this.fluidUntil = 'lg';
  }

  ngOnInit() {
    this.toggleFluidIfNeeded();
    $(window).on('resize', () => {
      this.toggleFluidIfNeeded();
    });
  }

  private toggleFluidIfNeeded(): void {
    if (window.innerWidth < ScreenSize[this.fluidUntil] &&
      !this.fluidActive) {
      this.fluidActive = true;
      this.breakingActive = false;
    } else if (window.innerWidth >= ScreenSize[this.fluidUntil] && !this.breakingActive) {
      this.breakingActive = true;
      this.fluidActive = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directive/fluid-container.directive.ts